// extracted by mini-css-extract-plugin
module.exports = {"footer":"_1jO6aDXd6j-xiq6kFW9kkt","link":"_18quiXRMTxUYEV31OoePr5"};